import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import NewSearch from "../dialogs/NewSearch";

class NewSearchComponent extends Component {
  state = {
    addressText: "",
  };

  getPopupData = () => {
    const popupList = [];
    if (this.props.uiData !== undefined) {
      const menus = _.get(this.props.uiData, "Menus");
      const popupMenuList = _.get(menus, "PopupMenuList");
      const selectedPopupMenuList = _.filter(
        popupMenuList,
        (a) => a.FormType === this.props.popupType
      );
      _.map(_.groupBy(selectedPopupMenuList, "MenuGroup"), (value, key) => {
        popupList[key] = {
          titleName: key,
          titleImage: key,
          listItems: value,
        };
      });
    }
    return popupList;
  };

  render() {
    const popupData = this.getPopupData();
    return (
      <NewSearch key="new_search_dialog_1" data={popupData} {...this.props} />
    );
  }
}

function mapStateToProps(state) {
  return {
    uiData: state.uiData,
  };
}

export default connect(
  mapStateToProps,
  null
)(NewSearchComponent);



// WEBPACK FOOTER //
// ./src/components/common/NewSearchComponent.js